export class CardDataDto {
  first6?: string;
  last4?: string;
  cardTypeCode?: string;
  expiryYear?: number;
  expiryMonth?: number;
  name?: string;
  custom?: any;
}
